import {
  INVENTORY_SUPPLIER_PAGE_REQUEST,
  INVENTORY_SUPPLIER_SUPPLIERS_REQUEST,
  INVENTORY_SUPPLIER_ON_CHANGE_KEYWORD,
  INVENTORY_SUPPLIER_EXPORT_SUPPLIER,
  INVENTORY_SUPPLIER_ON_CLICK_ROW,
  INVENTORY_SUPPLIER_ASK_DELETE_SUPPLIER,
  INVENTORY_SUPPLIER_CANCEL_DELETE_SUPPLIER,
  INVENTORY_SUPPLIER_DELETE_SUPPLIER,
  INVENTORY_SUPPLIER_ON_CLICK_CANCEL,
  INVENTORY_SUPPLIER_ON_CLICK_CREATE_SUPPLIER,
  INVENTORY_SUPPLIER_SUBMIT_FORM_CREATE,
  INVENTORY_SUPPLIER_SUBMIT_FORM_UPDATE,
  INVENTORY_SUPPLIER_EXPORT_FAILED,
} from 'actions/inventory/supplier/constants';
import { takeLatest, put, call } from 'redux-saga/effects';
import * as actSupplier from 'actions/inventory/supplier';
import * as act from 'actions';
import * as apiInvSupplier from 'api/inventory/suppliers';
import * as apiOutlets from 'api/outlets';
import { initialize } from 'redux-form';
import * as actNotif from 'actions/notifications';
import { delay } from 'redux-saga';
import * as apiProfile from 'api/profile';
import { showPageLoadingSpinner } from 'actions/loadingSpinner';
import * as clevertapInventorySuppliers from 'clevertap/inventory/suppliers';

export function* initializeForm(supplier) {
  yield put(
    initialize('supplier', {
      id: supplier.id,
      name: supplier.name,
      address: supplier.address,
      city: supplier.city,
      email: supplier.email,
      phone: supplier.phone,
      postal_code: supplier.postal_code,
      state: supplier.state,
    })
  );
}

export function* emptyForm() {
  yield put(initialize('supplier', {}));
}

export function* pageRequestFlow() {
  // reset...
  yield put(actSupplier.setSuppliers([]));
  // set false by suppliers request saga
  yield put(showPageLoadingSpinner(true));
  yield put(actSupplier.setSupplierDetail(null));
  yield put(actSupplier.closeRightColumn());

  yield put(act.showProgressBar());
  try {
    const response = yield call(apiOutlets.outlets);
    yield put(actSupplier.setOutlets(response.data));

    const resProfile = yield call(apiProfile.getProfile);
    yield put(actSupplier.setProfile(resProfile.data));

    yield put(actSupplier.suppliersRequest({}));

    yield put(
      initialize('search', {
        keyword: '',
      })
    );
    clevertapInventorySuppliers.inventorySupplierStart();
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* suppliersRequest(request) {
  const {
    payload: { params },
  } = request;
  yield put(act.showProgressBar());
  try {
    const resSuppliers = yield call(apiInvSupplier.getSuppliers, params);
    const suppliers = resSuppliers.data;

    yield put(actSupplier.setSuppliers(suppliers));
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
    yield put(showPageLoadingSpinner(false));
  }
}

export function* onChangeKeyword(request) {
  yield put(actSupplier.setSuppliers([]));
  // set false by suppliers request saga
  yield put(showPageLoadingSpinner(true));
  const {
    payload: { keyword },
  } = request;
  // delay to prevent too fast ajax request
  yield call(delay, 300);
  yield put(actSupplier.suppliersRequest({ keyword }));
}

export function* exportSupplier(request) {
  yield put(act.showLoadingSpinner(true));
  try {
    yield put(actSupplier.startExportSupplier());
    const { email, keyword } = request.payload.params;
    const { data } = yield call(
      apiInvSupplier.getExportSupplier,
      email,
      keyword
    );
    yield put(actSupplier.setIdAsyncJob(data));
  } catch (error) {
    yield put(actSupplier.doneExportSupplier());
    yield put(act.showLoadingSpinner(false));
    yield put(actNotif.error(error.message));
  }
}

export function* exportSupplierFailed(error) {
  yield put(act.showLoadingSpinner(false));
  yield put(actNotif.error(error.message));
}

export function* onClickRow(request) {
  const {
    payload: { supplier },
  } = request;
  clevertapInventorySuppliers.inventorySupplierSelect({ supplier });
  yield put(actSupplier.setSupplierDetail(supplier));
  yield put(actSupplier.openRightColumn());
  yield call(initializeForm, supplier);
}

export function* onClickCancel() {
  yield put(actSupplier.setSupplierDetail(null));
  yield call(emptyForm);
  yield put(actSupplier.closeRightColumn());
}

export function* askDeleteSupplier() {
  yield put(actSupplier.openDeleteSupplierModal());
}

export function* deleteSupplier(request) {
  const {
    payload: { supplier, suppliers },
  } = request;
  clevertapInventorySuppliers.inventorySupplierDelete({ supplier });
  yield put(act.showProgressBar());
  try {
    yield call(apiInvSupplier.deleteSupplier, supplier.id, supplier.name);

    yield put(actSupplier.closeRightColumn());
    yield put(actSupplier.setSupplierDetail(null));
    yield put(actSupplier.closeDeleteSupplierModal());
    // remove supplier from list of suppliers
    const newSuppliers = [];
    suppliers.forEach(s => {
      if (s.id !== supplier.id) {
        newSuppliers.push(s);
      }
    });
    yield put(actSupplier.setSuppliers(newSuppliers));
    yield put(actNotif.success('Supplier successfully deleted.'));
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* cancelDeleteSupplier() {
  yield put(actSupplier.closeDeleteSupplierModal());
}

export function* onClickCreateSupplier() {
  yield put(actSupplier.openRightColumn());
  yield put(actSupplier.setSupplierDetail(null));
  yield call(emptyForm);
}

export function* submitFormCreate(request) {
  const {
    payload: { data, previousSuppliers },
  } = request;
  clevertapInventorySuppliers.inventorySupplierCreate({
    supplier: data.supplier,
  });
  try {
    yield put(act.showProgressBar());
    yield put(actSupplier.isSubmittingForm(true));
    // TODO should be return error message from backend instead of api call like this
    const { email } = data.supplier;
    // check email uniqueness
    const checkEmailResponse = yield call(apiInvSupplier.getSuppliers, {
      keyword: email,
    });
    let emailExist = false;
    checkEmailResponse.data.forEach(sup => {
      if (sup.email === email) emailExist = true;
    });
    if (emailExist) {
      // noinspection ExceptionCaughtLocallyJS
      throw new Error('Supplier email must be unique');
    }

    const supResponse = yield call(
      apiInvSupplier.postSuppliers,
      data.supplier,
      {}
    );
    const supplier = supResponse.data;
    yield call(initializeForm, supplier);
    previousSuppliers.unshift(supplier);
    yield put(actSupplier.setSupplierDetail(supplier));
    yield put(actSupplier.setSuppliers(previousSuppliers));
    yield put(actNotif.success('Supplier successfully created.'));
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(actSupplier.isSubmittingForm(false));
    yield put(act.hideProgressBar());
  }
}

export function* submitFormUpdate(request) {
  const {
    payload: { data, supplierId, previousSuppliers },
  } = request;
  try {
    yield put(act.showProgressBar());
    yield put(actSupplier.isSubmittingForm(true));
    // TODO should be return error message from backend instead of api call like this
    const { email } = data.supplier;
    // check email uniqueness
    const checkEmailResponse = yield call(apiInvSupplier.getSuppliers, {
      keyword: email,
    });
    let emailExist = false;
    checkEmailResponse.data.forEach(sup => {
      if (sup.email === email && sup.id !== supplierId) {
        emailExist = true;
      }
    });
    if (emailExist) {
      // noinspection ExceptionCaughtLocallyJS
      throw new Error('Supplier email must be unique');
    }

    const supResponse = yield call(
      apiInvSupplier.putSupplier,
      supplierId,
      data.supplier,
      {}
    );
    const supplier = supResponse.data;
    yield call(initializeForm, supplier);
    const newSuppliers = previousSuppliers.map(s => {
      if (s.id === supplier.id) {
        // return updated supplier
        return supplier;
      }
      return s;
    });
    yield put(actSupplier.setSupplierDetail(supplier));
    yield put(actSupplier.setSuppliers(newSuppliers));
    yield put(actNotif.success('Supplier successfully updated.'));
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
    yield put(actSupplier.isSubmittingForm(false));
  }
}

export default function* saga() {
  yield takeLatest(INVENTORY_SUPPLIER_PAGE_REQUEST, pageRequestFlow);
  yield takeLatest(INVENTORY_SUPPLIER_SUPPLIERS_REQUEST, suppliersRequest);
  yield takeLatest(INVENTORY_SUPPLIER_EXPORT_SUPPLIER, exportSupplier);
  yield takeLatest(INVENTORY_SUPPLIER_EXPORT_FAILED, exportSupplierFailed);
  yield takeLatest(INVENTORY_SUPPLIER_ON_CHANGE_KEYWORD, onChangeKeyword);
  yield takeLatest(INVENTORY_SUPPLIER_ON_CLICK_ROW, onClickRow);
  yield takeLatest(INVENTORY_SUPPLIER_ON_CLICK_CANCEL, onClickCancel);
  yield takeLatest(INVENTORY_SUPPLIER_ASK_DELETE_SUPPLIER, askDeleteSupplier);
  yield takeLatest(INVENTORY_SUPPLIER_DELETE_SUPPLIER, deleteSupplier);
  yield takeLatest(
    INVENTORY_SUPPLIER_CANCEL_DELETE_SUPPLIER,
    cancelDeleteSupplier
  );
  yield takeLatest(
    INVENTORY_SUPPLIER_ON_CLICK_CREATE_SUPPLIER,
    onClickCreateSupplier
  );
  yield takeLatest(INVENTORY_SUPPLIER_SUBMIT_FORM_CREATE, submitFormCreate);
  yield takeLatest(INVENTORY_SUPPLIER_SUBMIT_FORM_UPDATE, submitFormUpdate);
}
